import Box from "ds/components/Box";
import Table from "ds/components/Table";
import TableHead from "ds/components/Table/Head";
import TableBody from "ds/components/Table/Body";
import TableBodyRow from "ds/components/Table/Row";
import TableCell from "ds/components/Table/Row/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type ClaimMapping = {
  name: string;
  value: string;
};

type ClaimMappingsTableProps = {
  mappings: ClaimMapping[];
};

const ClaimMappingsTable = ({ mappings }: ClaimMappingsTableProps) => {
  return (
    <Box className={styles.tableContainer}>
      <Table ariaLabel="Claim mappings" layout="auto">
        <TableHead>
          <TableCell role="rowheader" className={styles.headerCell}>
            <Typography tag="span" variant="p-t7">
              Provider claim name
            </Typography>
          </TableCell>
          <TableCell role="rowheader" className={styles.headerCell}>
            <Typography tag="span" variant="p-t7">
              Spacelift claim name
            </Typography>
          </TableCell>
        </TableHead>
        <TableBody>
          {mappings.map((mapping, index) => (
            <TableBodyRow key={index}>
              <TableCell>
                <TableCellText>{mapping.name}</TableCellText>
              </TableCell>
              <TableCell>
                <TableCellText>{mapping.value}</TableCellText>
              </TableCell>
            </TableBodyRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ClaimMappingsTable;
